export { default } from "./CatalogDetail";
export * from "./CatalogDetail";
